<template>
<v-flex px-5 py-4 lg-2-of-10 xs4 class="flex-item" :class="{'shadow-hover': folderHover}">
  <div class="folder-parent-enfant pointer">

    <div class="loader" :class="{'visible': !loader}">
      <v-icon>mdi-loading mdi-spin</v-icon>
    </div>

    <div @click="enterIntoProj" class="img-container">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 60 51" enable-background="new 0 0 60 51" xml:space="preserve">
        <polygon @mouseenter="folderHover = true" @mouseleave="folderHover = false" fill="#4EB5E2" points="32,12 60,12 60,5 27,5 "/>
        <polygon @mouseenter="folderHover = true" @mouseleave="folderHover = false" fill="#266D8C" points="30,14 25,7 20,0 0,0 0,7 0,51 60,51 60,14 "/>
        <polygon :class="{'hide': parentSelected}" @mouseenter="folderHover = true" @mouseleave="folderHover = false" fill="#7DFFAF" points="32,12 60,12 60,5 27,5 "/>
        <polygon :class="{'hide': parentSelected}" @mouseenter="folderHover = true" @mouseleave="folderHover = false" fill="#54A774" points="30,14 25,7 20,0 0,0 0,7 0,51 60,51 60,14 "/>
      </svg>
      <span :class="{'hide': parentSelected}" @mouseenter="folderHover = true" @mouseleave="folderHover = false" class="child-name">{{projects.selected.name}}</span>
      <button v-if="deletable" @click="deleteProject" class="btn-delete">
        <img class="delete-img" src="../assets/img/delete-button.png" alt="">
      </button>
    </div>
    <div class="name-container">
      <div 
        :title="projects.parent.name" 
        class="name-text"
        :class="{'unique-proj': projects.all.length !== 1}"
      >{{projects.parent.name}}</div>
    </div>
    <div :title="projects.selected.name">
      <v-select
        class="select"
        v-model="projects.selected"
        :items="projects.all"
        return-object
        item-text="name"
        solo
        :disabled="projects.all.length === 1"
        :class="{'unique-select': projects.all.length === 1}"
      ></v-select>
    </div>
  </div>
</v-flex>
</template>

<script>
export default {
  props: {
    deletable: Boolean || false,
    projects: Object
  },
  computed: {
    parentSelected() {
      return this.projects.selected.uuid === this.projects.parent.uuid;
    }
  },
  data() {
    return {
      loader: false,
      folderHover: false,
    }
  },
  methods: {
    loaded() {
      this.loader = false;
    },
    deleteProject() {
      if (this.projects.parent.uuid === this.projects.selected.uuid)
        this.$emit('delete-project', this.projects.all);
      else 
        this.$emit('delete-project', [this.projects.selected]);
    },
    enterIntoProj() {
      if (!this.folderHover) return;
      this.$router.push("/projects/" + this.projects.selected.uuid)
      this.$store.commit("project/setLatestProj", this.projects.selected);
    }
  },
}
</script>
<style lang="sass">
// $text-color: #dfdfdf
$text-color: white
$bg-color: #4a4a4a
$active: #f1e341

.flex-item 
  display: flex !important
  align-items: flex-end
  position: relative
  margin-bottom: 2rem
  border-radius: 5px
  transition: box-shadow ease .3s
  &.shadow-hover
    box-shadow: 0 0 10px black
    cursor: pointer
.flex-item.xs1
  padding: .5rem !important
.folder-parent-enfant 
  width: 100%
  .img-container
    position: relative
    &>img 
      width: 100%
    .delete-img 
      width: 2.5rem
    svg polygon
      opacity: 1
      transition: opacity .5s ease
    svg .hide
      opacity: 0
    .child-name
      cursor: pointer
      font-size: 1.3rem
      font-weight: bold
      position: absolute 
      bottom: 40%
      left: 0
      width: 100%
      text-align: center
      opacity: 1
      transition: opacity .5s ease, bottom .3s ease
      transform: translateY(50%)
      &.hide 
        opacity: 0
        bottom: -3.25rem


  // NAME !
  .name-container
    text-align: center
    margin-top: 2rem
    position: relative
    background-color: $bg-color
    .name-text
      height: 2.5rem
      width: 100%
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
      color: $text-color
      font-size: 1.3rem
      padding: .2rem .8rem
      text-transform: uppercase
      cursor: default
      transition: color .3s ease-out
      &.unique-proj
        width: calc(100% - 2rem);
        padding-left: 2rem
 
  .btn-delete 
    position: absolute
    top: 0
    right: -1rem


  // SELECT !
  .select 
    margin-top: -2.5rem
    font-size: 1.3rem
    text-transform: uppercase
    .v-input__slot
      margin-bottom: 0
      min-height: 2.5rem
      height: 2.5rem
      background-color: transparent !important
    .v-select__selections
      opacity: 0
      width: calc(100% - 2rem);
    .v-select__selection
      margin: auto !important
      padding-left: 2rem
      color: $text-color
      text-overflow: ellipsis
      display: inline
      overflow: hidden
      white-space: nowrap
    .v-text-field__details
      display: none
    .v-input__control
      min-height: 2.5rem
    input
      display: none
  .unique-select 
    .v-select__selection
      padding-left: 0
    .v-input__append-inner
      display: none
.xs1 .folder-parent-enfant 
  .v-select__selection
    margin: auto !important
    padding-left: 0
 

// LOADER !
.folder-parent-enfant
  .loader 
    position: absolute
    top: 0
    bottom: 0
    width: 100%
    background: #171717
    z-index: 2
    display: flex 
    align-items: center
    opacity: 1
    transition: all ease .4s
    &.visible 
      visibility: hidden !important
      transition: visibility linear 0 .5s
      opacity: 0 !important
    i 
      margin: auto
      font-size: 2rem
</style>